import React from 'react'
import { Row, Col, Container } from 'react-bootstrap';
import { useTranslation } from "react-i18next";

const Whyus = () => {
    const { t } = useTranslation();

    return (
        <section className='whyus'>
            <Container>
                <Row>
                    <Col md={12}>
                        <div className='why-title text-center'>
                            <h3>{t('whyUs.title')}</h3>
                            <h5>{t('whyUs.subtitle')}</h5>
                        </div>
                        <div className='whyus-content'>
                            <div className='box-why-choose'>
                                <div className='box-why-image'>
                                    <img src={require("../assets/images/why-b-01.png")} alt="img" className="img-fluid" />
                                </div>
                                <h5>{t('whyUs.benefits.card1.title')}</h5>
                                <p>{t('whyUs.benefits.card1.description')}</p>
                            </div>
                            <div className='box-why-choose'>
                                <div className='box-why-image'>
                                    <img src={require("../assets/images/why-b-02.png")} alt="img" className="img-fluid" />
                                </div>
                                <h5>{t('whyUs.benefits.card2.title')}</h5>
                                <p>{t('whyUs.benefits.card2.description')}</p>
                            </div>
                            <div className='box-why-choose'>
                                <div className='box-why-image'>
                                    <img src={require("../assets/images/why-b-03.png")} alt="img" className="img-fluid" />
                                </div>
                                <h5>{t('whyUs.benefits.card3.title')}</h5>
                                <p>{t('whyUs.benefits.card3.description')}</p>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    )
}

export default Whyus;
